
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}},[_c('path',{attrs:{"d":"M32 18v-2h-6.04c-.183-2.271-.993-4.345-2.24-6.008h5.061l2.189-8.758-1.94-.485-1.811 7.242H21.76l-.084-.064c.21-.609.324-1.263.324-1.944 0-3.305-2.686-5.984-6-5.984s-6 2.679-6 5.984c0 .68.114 1.334.324 1.944l-.084.064H4.781L2.97.749l-1.94.485 2.189 8.758H8.28C7.034 11.655 6.224 13.728 6.04 16H0v2h6.043a11.782 11.782 0 001.051 3.992H3.219L1.03 30.749l1.94.485 1.811-7.243h3.511c1.834 2.439 4.606 3.992 7.708 3.992s5.874-1.554 7.708-3.992h3.511l1.811 7.243 1.94-.485-2.189-8.757h-3.875A11.76 11.76 0 0025.957 18H32z"}})])
      }
    
      }
    